var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-ctime" },
    [
      _c(
        "van-popup",
        {
          style: { height: "35%" },
          attrs: { position: "bottom" },
          on: { close: _vm.closePop },
          model: {
            value: _vm.showPop,
            callback: function ($$v) {
              _vm.showPop = $$v
            },
            expression: "showPop",
          },
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: "date",
              title: "",
              "cancel-button-text": _vm.$t("lang.cfm.cancelBtn"),
              "confirm-button-text": _vm.$t("lang.confirm"),
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate,
              formatter: _vm.formatter,
            },
            on: {
              confirm: function ($event) {
                return _vm.confirm(_vm.currentDate)
              },
              cancel: function ($event) {
                return _vm.cancel(_vm.currentDate)
              },
            },
            model: {
              value: _vm.currentDate,
              callback: function ($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }